import {share} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {
    PagedListOfCompanyMailingReport,
    PagedListOfProcessingReport,
    PaymentProcessingClient,
    PledgeClient,
    PledgeReportParams, ShiftPledgeReportSummary, SimpleBooleanResult
} from './api.client';
import {NotificationService} from './NotificationService';
import {saveAs} from 'file-saver';

@Injectable()
export class PaymentProcessingService {

    constructor(private _reportApiService: PaymentProcessingClient,
                private _pledgeApiService: PledgeClient,
                private _notificationService: NotificationService) {
    }

    buildCompanyMailingLabels({
                                  displayPledgeStatus, shiftPledgeStatus, startDate,
                                  endDate, pledgeTypeId, pledgeTypeIds, companyId,
                                  agencyId, entryDate
                              }: PledgeReportParams): Observable<PagedListOfCompanyMailingReport> {
        return this._reportApiService.buildCompanyMailingLabels(
            displayPledgeStatus,
            shiftPledgeStatus,
            startDate,
            endDate,
            pledgeTypeId,
            pledgeTypeIds,
            companyId,
            agencyId,
            entryDate
        ).pipe(share());
    }

    buildCompanyMailingLabelsUrl(): void {
        // return this._reportApiService.buildUrl('downloadCompanyMailingLabels',
        //   new URLSearchParams(this.getQueryParameters(reportParams)));
    }

    buildProcessingDetailReport(reportParams: PledgeReportParams): Observable<PagedListOfProcessingReport> {
        return this._reportApiService.buildProcessingSummaryReport(reportParams).pipe(share());
    }

    buildProcessingDetailReportUrl(reportParams: PledgeReportParams): void {
        this._reportApiService.downloadProcessingSummaryReport(reportParams)
            .subscribe(result => {
                const currentDate = new Date();
                const fileName = `Pledge Report-${currentDate.getFullYear() + '-' + (currentDate.getMonth() + 1) +
                '-' + currentDate.getDate()}.csv`;
                // There is a problem where the filename wasn't being parsed by nswag.
                saveAs(result.data, fileName);
            });
    }

    buildShiftPledgeReport({
                               displayPledgeStatus,
                               shiftPledgeStatus,
                               startDate,
                               endDate,
                               pledgeTypeId,
                               pledgeTypeIds,
                               companyId,
                               agencyId,
                               entryDate
                           }: PledgeReportParams): Observable<ShiftPledgeReportSummary[]> {
        return this._reportApiService.buildShiftPledgeReport(
            displayPledgeStatus,
            shiftPledgeStatus,
            startDate,
            endDate,
            pledgeTypeId,
            pledgeTypeIds,
            companyId,
            agencyId,
            entryDate
        ).pipe(share());
    }

    // getManualPendingToPaidPledges(reportParams: string[]): Observable<Pledge[]> {
    //     let request = this._pledgeApiService.getManualPendingPledges(reportParams).share();
    //     request.subscribe((data) => {
    //         let pendingPledges = data;
    //         return pendingPledges;
    //         // this.buildShiftPledgeReportSuccessAction(data);
    //     }, (error) => {
    //         // this.buildShiftPledgeReportFailedAction(error);
    //     });
    //     return request;
    // }

    changeUpdatePledgeStatus(reportParams: PledgeReportParams): Observable<SimpleBooleanResult> {
        if (reportParams.companyId === '') {
            reportParams.companyId = null;
        }
        const request = this._reportApiService.changePledgeStatus(reportParams).pipe(share());
        this._notificationService.showSuccess('Attempting to bulk update Pledge Status.');
        request.subscribe({
            next: () => {
                this._notificationService.showSuccess('Pledge Status bulk update completed!');
            }, error: () => {
                this._notificationService.showSuccess('Pledge Status bulk update completed!');
            }
        });
        return request;

    }
}
